export default __webpack_public_path__ + "static/media/lange.9c5a32b1.jpg";